module.exports = __webpack_public_path__ + "static/media/lwt_logo-black.5a5dc49e.svg";